import { auth } from "@/config/firebase";
import { useUser } from "@/context/user";
import { getRoutes, setCurrentUser, sleep } from "@/utils/helpers";
import { log } from "@/utils/logger";
import { applyActionCode, checkActionCode } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const useVerifyEmail = () => {
    const setLoading = useUser(state => state.setGlobalLoading);
    const routes = getRoutes();
    const navigate = useNavigate();

    const onVerifyEmail = async (oobCode: string | null) => {
        try {
            setLoading(true);

            if (!oobCode) throw new Error("Missing oobCode in parameters. $sentry-ignore");

            const {
                data: { email },
            } = await checkActionCode(auth, oobCode);
            await applyActionCode(auth, oobCode);

            log.success(
                email
                    ? `${email} has been successfully verified.`
                    : "Email has been successfully verified.",
            );

            if (auth.currentUser) await setCurrentUser(auth.currentUser);
            else navigate(routes.signIn);
        } catch (e) {
            log.error(e, "onVerifyEmail");

            await sleep(2000), navigate(routes.signIn);
        } finally {
            setLoading(false);
        }
    };

    return onVerifyEmail;
};

export { useVerifyEmail };
